/** Dialog shown during advanced RX creation when user's initial harvest history crop selections do not meet criteria
    for creating an advanced RX. */

import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

// @tcc
import { getMessage } from 'util/locale';

// selectors
import { getCropSelectionDoesNotMeetModal } from 'current/uiwidgets/selectors';

// actions
import { closeCropSelectionDoesNotMeetModal } from 'current/uiwidgets';

// components
import BaseModal from 'common/modals/BaseModal';
import { FIELD_VIEW_URL } from 'constants/urls';

const baseString = 'vra-crop-selection-does-not-meet-modal';
let CropSelectionDoesNotMeetModalContainer = ({
  cropSelectionDoesNotMeetModal,
  onCancel,
  onUploadYieldData
}) => cropSelectionDoesNotMeetModal ? (
  <BaseModal
    cancelText={getMessage('button-text__cancel')}
    onCancel={onCancel}
    onSave={onUploadYieldData}
    saveText={getMessage('button-text__upload-yield-data')}>
    <div className={`${baseString}`}>
      <p className={`${baseString}--title`}>
        { getMessage('help-text__harvest-history--crop-selection-does-not-meet--title') }
      </p>
      <p className={`${baseString}--info`}>
        { getMessage('help-text__harvest-history--crop-selection-does-not-meet') }
      </p>
    </div>
  </BaseModal>
) : null;

CropSelectionDoesNotMeetModalContainer.propTypes = {
  cropSelectionDoesNotMeetModal: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
  onUploadYieldData: propTypes.func.isRequired
};

CropSelectionDoesNotMeetModalContainer = connect(
  (state) => {
    return {
      cropSelectionDoesNotMeetModal: getCropSelectionDoesNotMeetModal(state),
    };
  },
  (dispatch) => {
    return {
      onCancel: () => {
        dispatch(closeCropSelectionDoesNotMeetModal());
      },
      onUploadYieldData: () => {
        dispatch(closeCropSelectionDoesNotMeetModal());
        // TODO add code for cleaning up new RX.
        window.location = FIELD_VIEW_URL.DATA_INBOX;
      }
    };
  }
)(CropSelectionDoesNotMeetModalContainer);

export default CropSelectionDoesNotMeetModalContainer;
